import { render, staticRenderFns } from "./formularioTromboembolico.vue?vue&type=template&id=8d75d4f8&scoped=true"
import script from "./formularioTromboembolico.vue?vue&type=script&lang=js"
export * from "./formularioTromboembolico.vue?vue&type=script&lang=js"
import style0 from "./formularioTromboembolico.vue?vue&type=style&index=0&id=8d75d4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d75d4f8",
  null
  
)

export default component.exports